/**
 * QA Sidekick runtime config.
 *
 * Defaults work for single-tenant self-host (Kuutio pattern):
 *   - API at relative /api/qa (same origin as app)
 *   - No API key
 *
 * For multi-tenant SaaS / standalone product:
 *   VITE_QA_API_URL=https://qa.example.com/api
 *   VITE_QA_API_KEY=qas_live_xxx
 *   VITE_QA_PROJECT_ID=my-project
 */

// Module-level mutable config so consumers can override at runtime
let runtime = {
  apiUrl: typeof import.meta !== 'undefined' && import.meta.env?.VITE_QA_API_URL
    ? import.meta.env.VITE_QA_API_URL
    : '/api/qa',
  apiKey: typeof import.meta !== 'undefined' && import.meta.env?.VITE_QA_API_KEY
    ? import.meta.env.VITE_QA_API_KEY
    : null,
  projectId: typeof import.meta !== 'undefined' && import.meta.env?.VITE_QA_PROJECT_ID
    ? import.meta.env.VITE_QA_PROJECT_ID
    : null,
};

export function configureQa({ apiUrl, apiKey, projectId }) {
  if (apiUrl !== undefined) runtime.apiUrl = apiUrl;
  if (apiKey !== undefined) runtime.apiKey = apiKey;
  if (projectId !== undefined) runtime.projectId = projectId;
}

export function getConfig() {
  return { ...runtime };
}

/**
 * Build endpoint URLs. All QA components use these instead of hardcoded paths.
 */
export const endpoints = {
  items: () => `${runtime.apiUrl}/items`,
  itemsSeed: () => `${runtime.apiUrl}/items/seed`,
  results: (week) => `${runtime.apiUrl}/results/${week}`,
  resultsSave: () => `${runtime.apiUrl}/results`,
  bugs: () => `${runtime.apiUrl}/bugs`,
  summary: () => `${runtime.apiUrl}/summary`,
};

/**
 * Standard headers for all QA API requests.
 * Adds Authorization + X-Project-Id when configured.
 */
export function qaHeaders(extra = {}) {
  const headers = { 'Content-Type': 'application/json', ...extra };
  if (runtime.apiKey) headers['Authorization'] = `Bearer ${runtime.apiKey}`;
  if (runtime.projectId) headers['X-Project-Id'] = runtime.projectId;
  return headers;
}
